module.exports = __webpack_public_path__ + "img/start_game.92524b42.jpg";